import { useContext } from "react";
import { SendingContext } from "../contexts/SendingContext";

export const useSending = () => {
  const context = useContext(SendingContext);
  if (context === undefined) {
    throw new Error("useSending must be used within a SendingProvider");
  }
  return context;
};
